import { addFilter, removeFilter } from '@wordpress/hooks';
import { TextControl, PanelRow } from '@wordpress/components';
import { dispatch } from '@wordpress/data';
import { __ } from '@wordpress/i18n';
import WPEditor from '../../../fields/WPEditor';

const Checkout = ( {allData} ) => {
    const { updateTripData } = dispatch('WPTravel/TripEdit')
    const wp_travel_trip_checkout_page_info = allData.utilities && allData.utilities.wp_travel_trip_checkout_page_info || ''
    const wp_travel_trip_checkout_page_info_label = allData.utilities && allData.utilities.wp_travel_trip_checkout_page_info_label || ''

    const handleChange = name => {
        return value => updateTripData({ ...allData, utilities: { ...allData.utilities, [name]: value } })
    }
    return <>
        <h3 className="wp-travel-tab-content-title">{__('Trip Specific Info Content', 'wp-travel-pro')}</h3>
        <PanelRow>
            <label>{__('Checkout Information Label', 'wp-travel-pro')}</label>
        <TextControl
            key="tabLabel"
            value={wp_travel_trip_checkout_page_info_label}
            onChange={handleChange('wp_travel_trip_checkout_page_info_label')}
            help={__('Label for Trip Specific info content to display in checkout page.( Leave Blank to remove label ) ', 'wp-travel-pro')}
        />
        </PanelRow>
        <PanelRow>
            <label>{__('Checkout Information', 'wp-travel-pro')}</label>
        </PanelRow>
        <PanelRow>
            <WPEditor
                id="wp-travel-checkout-info-content"
                onContentChange={handleChange('wp_travel_trip_checkout_page_info')}
                value={wp_travel_trip_checkout_page_info}
                help={__('Trip Specific info content to display in checkout page.( Below Checkout form ) ', 'wp-travel-pro')}
            />
        </PanelRow>
        <p className="components-form-token-field__help">{__('Trip Specific info content to display in checkout page.( Below Checkout form ) ', 'wp-travel-pro')}</p>
    </>
}

const CheckoutCB = ( content, allData ) => {
    return [ ...content, <Checkout allData={allData} /> ];
}

// Remove Utilities related notices
removeFilter( 'wptravel_trip_edit_tab_content_cart_checkout', 'WPTravel/TripEdit/CheckoutNotice' );

// Callbacks
addFilter( 'wptravel_trip_edit_tab_content_cart_checkout', 'WPTravelPro\TripEdit\Checkout', CheckoutCB, 10 );



